import { AfterViewInit, Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { KYMW00Model } from "src/app/commons/kymw00/kymw00.model";
import { PlessDialogServiceSub } from "src/app/commons/kymw00/pless-dialog-service-sub";
import { PlessViewHelperSub } from "src/app/commons/kymw00/pless-view-helper-sub";
import { KYMW7403Model } from "./kymw7403.model";
import { GetOutputTargetService } from "./api-services/get-output-target.service";
import { OutputRememberGoodsInfoService } from "./api-services/output-remember-goods-info.service";
import { OutputRememberGoodsDiffService } from "./api-services/output-remember-goods-diff.service";
import { PlessViewUtilsSub } from "src/app/commons/kymw00/pless-view-utils-sub.service";
import { FileDownloadConfirmService } from "src/app/commons/kymw02/file-download-confirm/file-download-confirm.service";
import { CheckboxLabelComponent } from "src/app/commons/kymw02/checkbox-label/checkbox-label.component";
import { WjAccordion } from '@grapecity/wijmo.angular2.nav';

/**
 * 忘れず注文商品リスト出力
 * 
 */
@Component({
  selector: 'app-kymw7403',
  templateUrl: 'kymw7403.component.html',
  styleUrls: ['kymw7403.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW7403Component extends PlessViewHelperSub implements OnInit, AfterViewInit {
  kymw7403Model: KYMW7403Model = new KYMW7403Model();

  @ViewChild('cmb_confirmData', { static: true }) cmb_confirmData: ElementRef;
  @ViewChild('chk_aheadEightWeeks', { static: true }) chk_aheadEightWeeks: CheckboxLabelComponent;
  @ViewChild('chk_includeUnapproval', { static: true }) chk_includeUnapproval: CheckboxLabelComponent;

  constructor(
    private dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private getOutputTargetService: GetOutputTargetService,
    private outputRememberGoodsInfoService: OutputRememberGoodsInfoService,
    private outputRememberGoodsDiffService: OutputRememberGoodsDiffService,
    private fileDownloadConfirmService: FileDownloadConfirmService
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   * 
   */
  ngOnInit(): void {
    this.componentName = "7403";
    this.kymw7403Model.kymw7403Component = this;

    // 確定データ取得
    this.getOutputTargetService.execute( (data) => {
      this.kymw7403Model.setConfirmList(data);
    });
  }

  /**
   * フォーカス制御
   * 
   * 以下3点が実装理由
   * 1. アコーディオンを閉じた際にメニュータイトルがtabindex=-1となる
   * 2. 2つのアコーディオンメニューを閉じた際に閉じるボタンからフォーカス移動ができない
   * 3. 2の状態でshift+tabを押下すると親画面の要素にフォーカスがいく
   */
  ngAfterViewInit(): void {
    const panels = document.querySelectorAll<HTMLElement>('.accordion-pane');
    panels.forEach( pane => {

      // アコーディオンメニュータイトル クリック時
      pane.addEventListener('click', ()=> {     
        setTimeout(() => {
          // 切り替わりで片方がtabindex=-1となるため、両方のアコーディオンメニューのtabindexを0にする
          panels.forEach (pane => {
            pane.tabIndex = 0;
          })
        })
      })

    })
  }

  /**
   * アコーディオンの初期処理
   * @param wad 
   * @param collapsed 
   */
  public initCollapsed(wad: WjAccordion, collapsed: boolean = true) {
    wad.panes.forEach(_ => ( _.isCollapsed = collapsed ));
    // 初期フォーカス設定
    document.querySelector<HTMLElement>('.accordion-pane').tabIndex = 0;
    this.cmb_confirmData.nativeElement.focus();
  }

  /**
   * コンボボックスで選択された対象データを抽出
   * 
   * @param selectId 
   * @returns 
   */
  public createVO(selectId) { 
    const selectedData = this.kymw7403Model.confirmList.find(data => 
      data.id === selectId
    )

    return selectedData;
  }

  /**
   * 出力ボタン（商品リスト） 押下
   * 
   */
  public eventOutputRememberGoodsInfo_CLICKHandler() {
    // 必須チェック
    if ( PlessViewUtilsSub.isEmpty(this.kymw7403Model.confirmDataId) ) {
      this.dialogService.openAlertGetMessage('W0001', ['出力対象データ']);
      return
    }
    if ( PlessViewUtilsSub.isEmpty(this.kymw7403Model.catalogId) ) {
      this.dialogService.openAlertGetMessage('W0001', ['出力対象企画回']);
      return
    }

    // VO作成
    const selectedData = this.createVO(this.kymw7403Model.confirmDataId);

    // チェックボックスのbooleanをAPIリクエスト用に設定
    // 初回selectedのfalseはnullとなるが期待通り'0'が入るため問題なし
    this.kymw7403Model.aheadEightWeeks = this.chk_aheadEightWeeks.selected ? '1': '0';
    this.kymw7403Model.includeUnapproval = this.chk_includeUnapproval.selected ? '1': '0';

    this.outputRememberGoodsInfoService.execute(this.kymw7403Model, selectedData, (data) => {
      // ファイル名設定
      let fileName: string = <string>'忘れず注文商品リスト_(';

      // 現在のデータ選択時のファイル名設定
      if ( selectedData.confirmUserId === '') {
        fileName += this.kymw7403Model.catalogId 
          + ')_' + PlessViewUtilsSub.formatedNowDate('YYYYMMDD_hhmmss') + '.csv';
        
      } else {
        // 確定データ選択時のファイル名の設定
        fileName += PlessViewUtilsSub.dateToString(new Date(selectedData.confirmDate), 'YYYYMMDD_hhmmss') 
          + ')_(' + selectedData.confirmUserName 
          + ')_(' + this.kymw7403Model.catalogId 
          + ')_' + PlessViewUtilsSub.formatedNowDate('YYYYMMDD_hhmmss') + '.csv';
      }
      
      // ファイルダウンロード
      this.fileDownloadConfirmService.show(data.FileName, fileName);
    });
  }

  /**
   * 出力ボタン（差分） 押下
   * 
   */
  public eventOutputRememberGoodsDiff_CLICKHandler() {
    // 必須チェック
    if ( PlessViewUtilsSub.isEmpty(this.kymw7403Model.confirmDataDiff) ) {
      this.dialogService.openAlertGetMessage('W0001', ['出力対象データ']);
      return
    }
    if ( PlessViewUtilsSub.isEmpty(this.kymw7403Model.catalogIdDiff) ) {
      this.dialogService.openAlertGetMessage('W0001', ['出力対象企画回']);
      return
    }
    if ( PlessViewUtilsSub.isEmpty(this.kymw7403Model.comparingData) ) {
      this.dialogService.openAlertGetMessage('W0001', ['比較対象データ']);
      return
    }
    if ( PlessViewUtilsSub.isEmpty(this.kymw7403Model.comparingCatalogId) ) {
      this.dialogService.openAlertGetMessage('W0001', ['比較対象企画回']);
      return
    }

    // 出力対象データ
    const selectedComfirmData = this.createVO(this.kymw7403Model.confirmDataDiff);
    // 比較対象データ
    const selectedComparingData = this.createVO(this.kymw7403Model.comparingData);

    this.outputRememberGoodsDiffService.execute(this.kymw7403Model, selectedComfirmData, selectedComparingData, (data) => {
      // ファイル名設定
      let fileName = '忘れず注文差分リスト_(' + this.kymw7403Model.catalogIdDiff 
        + ')_' + PlessViewUtilsSub.formatedNowDate('YYYYMMDD_hhmmss') + '.xlsx';

      // ファイルダウンロード
      this.fileDownloadConfirmService.show(data.FileName, fileName);
    })
  }
}